import muslimCalender from './muslimCalendarBg.png';
import muslimCalenderLogo from './muslimCalendarLogo.png';
import sevnCloudLogo from './sevnCloudLogo.png';
import sevnCloudBg from './sevnCloudBg.png';
import u4riaLogo from './u4riaLogo.png';
import u4riaBg from './u4riaBg.png'
import mugClubLogo from './mugClubLogo.png';
import mugClubBg from './mugClubBg.png'
import okTreatLogo from './okTreatLogo.png';
import okTreatBg from './oKTreatBg.png';
import movieBg from './moviebg.png';
import topRated from './topRatedMovies.png';
import trendingMovie from './trendingMovies.png'
import profilePic from './bgremove.png';
import updatePortfolio from './updateportfolioImg.png';
import simplyJournalingLogo from './simplyJournalingLogo.png'
import simplyJournalingBg from './simplyJournalingBg.png'
import appStoreLogo from './appstore.jpeg'
import playStoreLogo from './google_play_logo.jpg'
import typeScript from './typeScript.png'
import githubLogo from './githubLogo.png'
import mongodb from './mongodb.png'
import express from './express.png'
import linkedin from './linkedin.png'
import xcode from './xcode.jpeg'
import androidStudio from './android_studio.png'
// import activityMapBg from './activityMapBg.png'
import activityMapLogo from './activityMapLogo.png'
import activityMapBg from './activityBg.jpg'
import shopeaseBg from './shopeaseBg.png'
import shopeaseProducts from './shopeaseProducts.png'
import shopeaseCart from './shopeaseCart.png'



export const AppImages = {
  muslimCalender,
  muslimCalenderLogo,
  sevnCloudBg,
  sevnCloudLogo,
  u4riaLogo,
  u4riaBg,
  mugClubLogo,
  mugClubBg,
  okTreatLogo,
  okTreatBg,
  movieBg,
  topRated,
  trendingMovie,
  profilePic,
  updatePortfolio,
  simplyJournalingLogo,
  simplyJournalingBg,
  appStoreLogo,
  playStoreLogo,
  typeScript,
  githubLogo,
  mongodb,
  express,
  linkedin,
  xcode,
  androidStudio,
  activityMapLogo,
  activityMapBg,
  shopeaseBg,
  shopeaseProducts,
  shopeaseCart
};

